import { svg } from "../svg";

// Keep the export name for the existing navigation API while rendering MavenInject branding.
const PasswordManagerLogo = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 49" fill="none">
    <title>MavenInject Vault</title>
    <rect x="2" y="4" width="41" height="41" rx="12" class="tw-fill-brand" />
    <path d="M11 35V14h5.3L22.5 25 28.7 14H34v21h-4.6V22.1l-4.6 7.6h-4.6l-4.6-7.6V35H11Z" class="tw-fill-text-alt2" />
    <text x="53" y="32" class="tw-fill-fg-nav" font-family="Inter, 'Helvetica Neue', Arial, sans-serif" font-size="23" font-weight="700" letter-spacing="-0.45">MavenInject</text>
  </svg>
`;

export default PasswordManagerLogo;
